// The "copied" mark of a copy button: shown after a copy, back to the copy
// icon after a while. Pressed again, it counts from that press; the timer
// goes with the button.
import { useCallback, useEffect, useRef, useState } from "react";

/** How long the mark stays. */
export const COPIED_MARK_MS = 2000;

/** The mark, and what to call once the words are on the clipboard. */
export function useCopiedMark(): [boolean, () => void] {
  const [copied, setCopied] = useState(false);
  const timer = useRef<number | undefined>(undefined);
  // frontend-development: not a fetch; drops the pending reset when the button goes.
  useEffect(() => () => window.clearTimeout(timer.current), []);
  const mark = useCallback(() => {
    window.clearTimeout(timer.current);
    setCopied(true);
    timer.current = window.setTimeout(() => setCopied(false), COPIED_MARK_MS);
  }, []);
  return [copied, mark];
}
